import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertModalService {
    
    onToggleAlertModal = new Subject<boolean>();
    
    constructor() { }
    
    show(){
        this.onToggleAlertModal.next(true);
    }
    
    hide(){
        this.onToggleAlertModal.next(false);
    }
}
